/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useState } from "react"
import { Button, Grid } from "@cd2/components"
import { LabelInfo } from "./LabelInfo"
import { brandColors } from "./EOSThemeProvider"
import { IComponentProps } from "@cd2/tools"

interface IProps {
  data: IComponentProps<typeof LabelInfo>[]
  moreData?: IComponentProps<typeof LabelInfo>[]
  inline?: boolean
  labelWidth?: number
  light?: boolean
  gap?: number
  startExpanded?: boolean
}

export function KeyValueList({
  data,
  moreData,
  inline,
  labelWidth,
  light,
  gap = 12,
  startExpanded = false,
}: IProps) {
  const [showMore, setShowMore] = useState(startExpanded)

  function mapData(data: IComponentProps<typeof LabelInfo>[]) {
    return data.map((datum, i) => (
      <LabelInfo key={i} inline={inline} light={light} labelWidth={labelWidth} {...datum} />
    ))
  }

  return (
    <Grid
      gap={gap}
      css={css`
        max-width: 100%;
        overflow: hidden;

        .label-info-value {
          max-width: 100%;
          overflow: hidden;

          p {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      `}
    >
      {mapData(data)}
      {showMore && moreData && mapData(moreData)}
      {moreData && (
        <div
          css={css`
            margin: 0 -8px -8px;
          `}
        >
          <Button
            onClick={() => setShowMore(!showMore)}
            buttonStyle="text"
            extendTheme={{ padding: 8, color: brandColors.emerald, fontSize: 12 }}
          >
            {showMore ? "Show less" : "Show more"}
          </Button>
        </div>
      )}
    </Grid>
  )
}
